import {
  AlertTriangle,
  CheckCircle,
  XCircle
} from 'lucide-react'

import { Badge } from 'slab'

export const StateStatusLegend = () => (
  <div className='space-y-3 text-white'>
    <div className='font-semibold text-sm border-b border-gray-600 pb-2'>
      S3 Status Legend
    </div>
    <div className='space-y-3'>
      <div className='flex items-center gap-3'>
        <Badge type='success' leftIcon={CheckCircle}>File Available</Badge>
        <span className='text-xs text-gray-300'>New file available in S3 - ingestion needed</span>
      </div>
      <div className='flex items-center gap-3'>
        <Badge type='info' leftIcon={CheckCircle}>Up to Date</Badge>
        <span className='text-xs text-gray-300'>Local data is up to date with S3</span>
      </div>
      <div className='flex items-center gap-3'>
        <Badge type='warning' leftIcon={AlertTriangle}>Update Available</Badge>
        <span className='text-xs text-gray-300'>Newer data available in S3 - re-ingestion recommended</span>
      </div>
      <div className='flex items-center gap-3'>
        <Badge type='critical' leftIcon={XCircle}>File Not Found</Badge>
        <span className='text-xs text-gray-300'>Data not available in S3</span>
      </div>
    </div>
  </div>
)
